import React, { ChangeEvent, InputHTMLAttributes } from "react";
import styled from "styled-components";
import { InputBox, Props as InputBoxProps } from "./InputBox";

interface InputContainerProps {
    $hasRightAddon: boolean;
}

export interface TextFieldProps extends Omit<
    InputHTMLAttributes<HTMLInputElement>,
    "className" | "onChange" | "value"
> {
    palette?: "primary" | "secondary";
    rightAddon?: JSX.Element;
    className?: string;
    value?: string | number;
    onChange?: (value: string) => void;
}

export const TextField = (props: TextFieldProps) => {
    const { rightAddon, className, onChange, value, palette, ...inputProps } =
        props;

    const onChangeHandler = (e: ChangeEvent<HTMLInputElement>) => {
        onChange?.(e.currentTarget.value);
    };

    const isShowRightAddon = !!String(value)?.length && rightAddon;

    return (
        <InputContainer $hasRightAddon={!!rightAddon} className={className}>
            <InputBox
                onChange={onChangeHandler}
                value={value}
                palette={palette}
                {...(inputProps as InputBoxProps)}
            />
            {isShowRightAddon && <RightAddon>{rightAddon}</RightAddon>}
        </InputContainer>
    );
};

const InputContainer = styled.div<InputContainerProps>`
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;

    ${InputBox} {
        padding-right: ${(props) => (props.$hasRightAddon ? "40px" : "16px")};
    }
`;

const RightAddon = styled.div`
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
`;
